import { Customs } from '../models/customs';
import { IncotermsEnum } from '../enum/incoterms.enum';
import { CustomsPurposeEnum } from '../enum/customs-purpose.enum';
import { CustomsRelationshipEnum } from '../enum/customs-relationship.enum';
import { CustomsPayorEnum } from '../enum/customs-payor.enum';

export const emptyCustoms: Customs = {
    termsOfSale: IncotermsEnum.EXW,
    purpose: CustomsPurposeEnum.SOLD,
    relationship: CustomsRelationshipEnum.NOT_RELATED,
    dutiesPayor: CustomsPayorEnum.SENDER,
    dutiesAccount: '',
    commercialInvoiceFreight: 0,
    commercialInvoiceInsurance: 0,
    commercialInvoiceSurcharge: 0,
    comments: '',
    commercialInvoice: false
};
